// extracted by mini-css-extract-plugin
export default {"root":"Threshold-module_root-fold0"};